module.exports = __webpack_public_path__ + "img/hy.c86a9e16.svg";